<template><div><h1 id="abbildungscodes" tabindex="-1"><a class="header-anchor" href="#abbildungscodes"><span>Abbildungscodes</span></a></h1>
<p>Abbildungscodes — Erfassung des Abbildungscodes im Fenster [Medienartikel]</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Beim Katalogverkauf ist interessant zu wissen, wie ein bestimmter Artikel im Katalog präsentiert wurde. Im Fenster [Medienartikel] kann der Abbildungscode festgehalten und für Auswertungen verfügbar gemacht werden. Diese Tabelle dient der Erfassung des Abbildungscodes im Fenster [Medienartikel].</p>
<p>Pfad: <code v-pre>Logistik → Tabellen → Abbildungscodes</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Abbildungscode</dt>
<dd>Abbildungscode für die Erfassung</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Abbildungscodes</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionalität</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/trade/artikel_und_lagerverwaltung.html" title="3. Artikel- und Lagerverwaltung">Lagerverwaltung</RouteLink></p>
</div></template>


